module.exports = __webpack_public_path__ + "img/Haamek_Hospital.e36e9692.svg";